/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewLocation
 */
export interface NewLocation {
    /**
     * 
     * @type {string}
     * @memberof NewLocation
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof NewLocation
     */
    type?: string;
}

/**
 * Check if a given object implements the NewLocation interface.
 */
export function instanceOfNewLocation(value: object): value is NewLocation {
    return true;
}

export function NewLocationFromJSON(json: any): NewLocation {
    return NewLocationFromJSONTyped(json, false);
}

export function NewLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewLocation {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function NewLocationToJSON(json: any): NewLocation {
    return NewLocationToJSONTyped(json, false);
}

export function NewLocationToJSONTyped(value?: NewLocation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'type': value['type'],
    };
}

